var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{attrs:{"formTitle":"Cadastro de Etapas/Atividades","cols":_vm.cols,"opts":_vm.opts,"customResource":_vm.resource,"descriptionProperty":"atividade"}})}
var staticRenderFns = []

export { render, staticRenderFns }